import { roleType } from '@common/config/ICode';
import { cx } from '@emotion/css';
import { useMyInfo } from '@hooks/myInfo/getMyInfo';
import IconBoracat from '@resources/icon/ico-logo.svg';
import { ISideMenu, isPublished } from '@src/common/config/Code';
import _ from 'lodash';
import { useMemo, useState } from 'react';
import type { LinkProps } from 'react-router-dom';
import {
  useLocation,
  useMatch,
  useNavigate,
  useResolvedPath
} from 'react-router-dom';
import HeaderRightMenu from '../header/HeaderRightMenu';
import { TopMenuStyle } from './TopMenu.style';

const TopMenu = () => {
  const { myInfo } = useMyInfo();

  const [roles, setRoles] = useState<roleType[]>(myInfo?.roles ?? []);

  const mainTo = useMemo(() => {
    if (myInfo?.roles?.includes?.('PM') || myInfo?.roles?.includes?.('PML')) {
      return '/dashboard';
    }
    if (myInfo?.roles?.includes?.('LL')) return '/tasktab';
    if (myInfo?.roles?.includes?.('TL')) return '/mytasktab';
    return '/';
  }, [myInfo?.roles]);

  const topMenuHome = {
    menu: { name: '', to: '/' }
  };

  const topMenuProject: ISideMenuMaker['sideMenu'] = {
    menu: {
      name: '프로젝트',
      to: '/project',
      pattern: /^\/?project\b|\/?taskManager\b/i
    },
    subMenu: isPublished
      ? [
          { name: '프로젝트 관리', to: '/project', roles: ['PML', 'PM'] }
          // {
          //   name: '작업 파일 관리',
          //   to: '/taskManager',
          //   roles: ['PML', 'PM']
          // }
        ]
      : [{ name: '프로젝트 관리', to: '/project', roles: ['PML', 'PM'] }]
  };

  const topMenuTask: ISideMenuMaker['sideMenu'] = {
    menu: {
      name: '작업',
      to: mainTo
    },
    subMenu: isPublished
      ? [
          {
            name: '전체 작업 조회',
            to: '/dashboard',
            roles: ['PML', 'PM']
          },
          {
            name: '전체 작업 목록',
            to: '/task/all',
            roles: ['PML', 'PM', 'LL', 'TL']
          },
          {
            name: '작업 관리',
            to: myInfo?.roles.find((el: any) => ['LL', 'TL'].includes(el))
              ? '/tasktab'
              : '/mytasktab',
            roles: ['LL', 'TL']
          }
          // { name: '작업자 배정', to: '/task', roles: ['LL'] },
          // { name: '내 작업', to: '/mytask', roles: ['TL'] }
        ]
      : [
          {
            name: '전체 작업 조회',
            to: '/dashboard',
            roles: ['PML', 'PM']
          },
          {
            name: '전체 작업 목록',
            to: '/task/all',
            roles: ['PML', 'PM', 'LL', 'TL']
          },
          {
            name: '작업 관리',
            to: myInfo?.roles?.includes?.('LL') ? '/tasktab' : '/mytasktab',
            roles: ['LL', 'TL']
          }
        ]
  };

  const topMenuStatistics: ISideMenuMaker['sideMenu'] = {
    menu: {
      name: '통계',
      to:
        myInfo?.roles?.includes?.('PML') || myInfo?.roles?.includes?.('PM')
          ? '/dashboard/workretention'
          : '/dashboard/workerresource'
    },
    subMenu: [
      {
        name: '업무 리텐션',
        to: '/dashboard/workretention',
        roles: ['PML', 'PM']
      },
      {
        name: '작업자 리소스',
        to: '/dashboard/workerresource',
        roles: ['PML', 'PM', 'LL']
      },
      {
        name: '작업자 퍼포먼스',
        to: '/dashboard/workerperformance',
        roles: ['PML', 'PM', 'LL']
      },
      {
        name: '파트별 퍼포먼스',
        to: '/dashboard/partperformance',
        roles: ['PML', 'PM', 'LL']
      }
      // {
      //   name: '고객사&프로젝트',
      //   to: '/dashboard/customer',
      //   roles: ['PML', 'PM', 'LL', 'TL']
      // },
      // {
      //   name: '작업자 별 포화도',
      //   to: '/dashboard/worker',
      //   roles: ['PML', 'PM', 'LL', 'TL']
      // },
      // {
      //   name: '언어 별 포화도',
      //   to: '/dashboard/languages',
      //   roles: ['PML', 'PM', 'LL', 'TL']
      // },
      // {
      //   name: '작업자 별 단어 수',
      //   to: '/dashboard/wordworker',
      //   roles: ['PML', 'PM', 'LL', 'TL']
      // },
      // {
      //   name: '언어 별 단어 수',
      //   to: '/dashboard/wordlanguage',
      //   roles: ['PML', 'PM', 'LL', 'TL']
      // }
    ]
  };

  useMemo(() => {
    setRoles(myInfo?.roles ?? []);
  }, [myInfo]);

  return (
    <TopMenuStyle>
      <div className="top-menu--left">
        <div className="top-menu--logo">
          <img
            className="top-menu--logo--boracat"
            src={IconBoracat}
            alt="boracat"
          />
        </div>
        <ul className="top-menu--menu--wrap">
          <TopMenuMaker roles={roles} sideMenu={topMenuHome}></TopMenuMaker>
          <TopMenuMaker roles={roles} sideMenu={topMenuProject}></TopMenuMaker>
          <TopMenuMaker roles={roles} sideMenu={topMenuTask}></TopMenuMaker>
          <TopMenuMaker
            roles={roles}
            sideMenu={topMenuStatistics}
          ></TopMenuMaker>
          {/* <li{
            style={{
              transform: 'translateY(2.5px)'
            }}
            onClick={() => {
              window.open('https://cat.boracat.com/', '_blank');
            }}
          >
            <IconBoraCATLink />
          </li>} */}
        </ul>
      </div>
      <div className="top-menu--right">
        <HeaderRightMenu />
      </div>
    </TopMenuStyle>
  );
};
export default TopMenu;

const ignoreProps = {
  name: '',
  roles: []
};

const CustomLink = ({
  children,
  to,
  pattern,
  ...props
}: ISideMenu & LinkProps) => {
  let resolved = useResolvedPath(to);
  let matched = useMatch({ path: resolved.pathname, end: true });
  const location = useLocation();
  const active =
    pattern instanceof RegExp
      ? pattern?.test(location.pathname)
      : location.pathname === '/mytasktab'
      ? to === '/tasktab'
      : Boolean(matched);

  const navigate = useNavigate();
  return (
    <a
      className={cx({ active })}
      onClick={() => {
        navigate(to);
      }}
      {...props}
    >
      {children}
    </a>
  );
};

interface ISideMenuMaker {
  roles: roleType[];
  sideMenu: {
    menu: Partial<ISideMenu>;
    subMenu?: ISideMenu[] | null;
    icon?: string;
  };
}

function TopMenuMaker({ roles, sideMenu }: ISideMenuMaker) {
  const { menu: mainMenu, subMenu, icon } = sideMenu;
  if (!subMenu?.length && mainMenu.to !== '/') return <></>;
  // let menu = mainMenu;
  // if (mainMenu.to !== '/' && !_.find(subMenu, { to: mainMenu.to })) {
  //   menu = { ...mainMenu, to: subMenu![0].to };
  // }

  // const mainMenuTo = useMemo(() => {
  //   if (mainMenu.to === undefined) {
  //     if (
  //       roles.includes('PM') ||
  //       roles.includes('PML') ||
  //       roles.includes('ADMIN')
  //     ) {
  //       return '/dashboard';
  //     }
  //     if (roles.includes('LL')) return '/tasktab';
  //     if (roles.includes('TL')) return '/mytasktab';
  //   }
  //   return mainMenu.to ?? '/';
  // }, [mainMenu]);

  const verifiedSubMenu = subMenu?.filter((el) => {
    return el.roles?.some((role) => roles.includes(role));
  });
  if (!verifiedSubMenu?.length) return <></>;

  return (
    <ul className="top-menu--menu">
      <li className="top-menu--ul--main" data-url={mainMenu.to}>
        <CustomLink
          to={mainMenu.to!}
          pattern={mainMenu.pattern}
          {...ignoreProps}
        >
          <div
            className={cx({
              'has-sub-menu':
                Array.isArray(verifiedSubMenu) && verifiedSubMenu.length > 0
            })}
          >
            {mainMenu.name}
          </div>
        </CustomLink>
        <ul className="top-menu--ul--sub">
          {Array.isArray(verifiedSubMenu) &&
            verifiedSubMenu.map((el) => {
              return (
                <li key={el.to} data-roles={el?.roles?.join()}>
                  <CustomLink to={el.to} {...ignoreProps}>
                    <span>{el.name}</span>
                  </CustomLink>
                </li>
              );
            })}
        </ul>
      </li>
    </ul>
  );
}

function IconBoraCATLink() {
  return (
    <svg
      width="67"
      height="22"
      viewBox="0 0 67 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.39966 6.228H5.41766C6.22966 6.228 6.86432 6.45667 7.32166 6.914C7.78832 7.37133 8.02166 7.98267 8.02166 8.748C8.02166 9.112 7.97032 9.42 7.86766 9.672C7.76499 9.924 7.63432 10.134 7.47566 10.302C7.31699 10.4607 7.14432 10.582 6.95766 10.666C6.77099 10.7407 6.59832 10.792 6.43966 10.82V10.904C6.61699 10.9133 6.81299 10.96 7.02766 11.044C7.25166 11.128 7.46166 11.2633 7.65766 11.45C7.85366 11.6273 8.01699 11.8607 8.14766 12.15C8.28766 12.43 8.35766 12.7707 8.35766 13.172C8.35766 13.5733 8.29232 13.9467 8.16166 14.292C8.04032 14.6373 7.86766 14.936 7.64366 15.188C7.41966 15.44 7.15366 15.6407 6.84566 15.79C6.53766 15.93 6.20166 16 5.83766 16H1.39966V6.228ZM2.57566 14.964H5.47366C5.97766 14.964 6.37432 14.838 6.66366 14.586C6.95299 14.3247 7.09766 13.9467 7.09766 13.452V12.976C7.09766 12.4813 6.95299 12.108 6.66366 11.856C6.37432 11.5947 5.97766 11.464 5.47366 11.464H2.57566V14.964ZM2.57566 10.456H5.27766C5.74432 10.456 6.10832 10.3393 6.36966 10.106C6.63099 9.87267 6.76166 9.53667 6.76166 9.098V8.622C6.76166 8.18333 6.63099 7.84733 6.36966 7.614C6.10832 7.38067 5.74432 7.264 5.27766 7.264H2.57566V10.456ZM12.9141 16.168C12.4288 16.168 11.9855 16.0793 11.5841 15.902C11.1828 15.7247 10.8375 15.4727 10.5481 15.146C10.2681 14.81 10.0488 14.4133 9.89014 13.956C9.73147 13.4893 9.65214 12.9667 9.65214 12.388C9.65214 11.8187 9.73147 11.3007 9.89014 10.834C10.0488 10.3673 10.2681 9.97067 10.5481 9.644C10.8375 9.308 11.1828 9.05133 11.5841 8.874C11.9855 8.69667 12.4288 8.608 12.9141 8.608C13.3995 8.608 13.8381 8.69667 14.2301 8.874C14.6315 9.05133 14.9768 9.308 15.2661 9.644C15.5555 9.97067 15.7795 10.3673 15.9381 10.834C16.0968 11.3007 16.1761 11.8187 16.1761 12.388C16.1761 12.9667 16.0968 13.4893 15.9381 13.956C15.7795 14.4133 15.5555 14.81 15.2661 15.146C14.9768 15.4727 14.6315 15.7247 14.2301 15.902C13.8381 16.0793 13.3995 16.168 12.9141 16.168ZM12.9141 15.174C13.5208 15.174 14.0155 14.9873 14.3981 14.614C14.7808 14.2407 14.9721 13.6713 14.9721 12.906V11.87C14.9721 11.1047 14.7808 10.5353 14.3981 10.162C14.0155 9.78867 13.5208 9.602 12.9141 9.602C12.3075 9.602 11.8128 9.78867 11.4301 10.162C11.0475 10.5353 10.8561 11.1047 10.8561 11.87V12.906C10.8561 13.6713 11.0475 14.2407 11.4301 14.614C11.8128 14.9873 12.3075 15.174 12.9141 15.174ZM17.7681 16V8.776H18.8881V10.106H18.9581C19.0888 9.76067 19.3221 9.45267 19.6581 9.182C19.9941 8.91133 20.4561 8.776 21.0441 8.776H21.4781V9.896H20.8201C20.2135 9.896 19.7375 10.0127 19.3921 10.246C19.0561 10.47 18.8881 10.7547 18.8881 11.1V16H17.7681ZM27.8541 16C27.4341 16 27.1307 15.888 26.9441 15.664C26.7667 15.44 26.6547 15.16 26.6081 14.824H26.5381C26.3794 15.272 26.1181 15.608 25.7541 15.832C25.3901 16.056 24.9561 16.168 24.4521 16.168C23.6867 16.168 23.0894 15.972 22.6601 15.58C22.2401 15.188 22.0301 14.656 22.0301 13.984C22.0301 13.3027 22.2774 12.78 22.7721 12.416C23.2761 12.052 24.0554 11.87 25.1101 11.87H26.5381V11.156C26.5381 10.6427 26.3981 10.2507 26.1181 9.98C25.8381 9.70933 25.4087 9.574 24.8301 9.574C24.3914 9.574 24.0227 9.672 23.7241 9.868C23.4347 10.064 23.1921 10.3253 22.9961 10.652L22.3241 10.022C22.5201 9.63 22.8327 9.29867 23.2621 9.028C23.6914 8.748 24.2327 8.608 24.8861 8.608C25.7634 8.608 26.4447 8.82267 26.9301 9.252C27.4154 9.68133 27.6581 10.2787 27.6581 11.044V15.02H28.4841V16H27.8541ZM24.6341 15.216C24.9141 15.216 25.1707 15.1833 25.4041 15.118C25.6374 15.0527 25.8381 14.9593 26.0061 14.838C26.1741 14.7167 26.3047 14.5767 26.3981 14.418C26.4914 14.2593 26.5381 14.0867 26.5381 13.9V12.71H25.0541C24.4101 12.71 23.9387 12.8033 23.6401 12.99C23.3507 13.1767 23.2061 13.4473 23.2061 13.802V14.096C23.2061 14.4507 23.3321 14.726 23.5841 14.922C23.8454 15.118 24.1954 15.216 24.6341 15.216ZM33.3886 16.168C32.1472 16.168 31.1812 15.748 30.4906 14.908C29.7999 14.0587 29.4546 12.8127 29.4546 11.17C29.4546 9.52733 29.7999 8.26733 30.4906 7.39C31.1812 6.50333 32.1472 6.06 33.3886 6.06C34.2099 6.06 34.8959 6.24667 35.4466 6.62C36.0066 6.99333 36.4406 7.52067 36.7486 8.202L35.7966 8.776C35.6006 8.272 35.3019 7.87067 34.9006 7.572C34.4992 7.264 33.9952 7.11 33.3886 7.11C32.9686 7.11 32.5906 7.18933 32.2546 7.348C31.9279 7.50667 31.6479 7.73533 31.4146 8.034C31.1906 8.32333 31.0179 8.67333 30.8966 9.084C30.7752 9.48533 30.7146 9.938 30.7146 10.442V11.898C30.7146 12.906 30.9479 13.6947 31.4146 14.264C31.8812 14.8333 32.5392 15.118 33.3886 15.118C34.0139 15.118 34.5366 14.9593 34.9566 14.642C35.3766 14.3153 35.6846 13.886 35.8806 13.354L36.8186 13.942C36.5106 14.6327 36.0672 15.1787 35.4886 15.58C34.9099 15.972 34.2099 16.168 33.3886 16.168ZM44.5079 16L43.5279 13.116H39.5799L38.5999 16H37.4099L40.8259 6.228H42.3239L45.7399 16H44.5079ZM41.5819 7.32H41.5119L39.8599 12.08H43.2339L41.5819 7.32ZM49.4826 7.264V16H48.3066V7.264H45.1986V6.228H52.5906V7.264H49.4826Z"
        fill="#242424"
      />
      <mask
        id="mask0_912_2306"
        // style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="56"
        y="6"
        width="10"
        height="10"
      >
        <rect x="56.5" y="6.5" width="9" height="9" rx="0.5" stroke="white" />
      </mask>
      <g mask="url(#mask0_912_2306)">
        <path
          d="M60.6681 11.4018V4.65356H54.0771V17.9228C54.0771 18.692 63.3079 18.2433 67.9233 17.9228V11.4018H60.6681Z"
          fill="#242424"
        />
      </g>
      <path
        d="M62.429 6H66.0004M66.0004 6V9.33333M66.0004 6L60.2861 11.7143"
        stroke="#242424"
        strokeLinecap="round"
      />
    </svg>
  );
}
